import React from 'react';
import PropTypes from 'prop-types';

import {
  RideButton,
  RideGlCoverageSolid,
  RideGlPremiumHealthSolid,
  RideGlRight,
  RideBadge,
} from '@rimac-seguros/ride-system-components';

const PlanItem = ({
  plan, className, onSelect, onShowMore, onShowClinics,
}) => {
  const discount = plan.discount.length > 0 ? plan.discount[0].porcDescuento : 0;

  return (
    <div className={`plan-item-full ${className}`}>
      {plan.isRecommend && <p className="plan-item-full_recommend">Recomendado</p>}
      {!!discount && (
        <RideBadge
          borderRadius="medium"
          case="promotional"
          cornerRoundedPositionBottom="left"
          cornerRoundedPositionTop="right"
          discountText={`${discount}%`}
          primaryText=""
          secondaryText="dscto. online"
          variant="tertiary"
          className="absolute top-0 right-0 z-10 w-min lg:!p-1 xl:!p-[10px]"
        />
      )}
      <div className={`plan-item-full_content ${plan.isRecommend ? 'recommend' : ''}`}>
        <div>
          <h4>{plan.name}</h4>
          <div className="plan-item-full_price">
            {!!discount && (
              <p className="plan-item-full_price-before">Antes <span>{plan.currency}.{plan.price}</span></p>
            )}
            <div className="plan-item-full_price-container">
              <span className="plan-item-full_price-detail">
                <small>{plan.currency}</small>
                {plan.priceDiscount || plan.price}
              </span>
              <span className="plan-item-full_price-period">/{plan.period}</span>
            </div>
          </div>
          <div className={`plan-item-full_description ${plan.showClinics ? 'show-clinics' : ''}`}>
            <p>{plan.description}</p>
            {plan.showClinics && (
              <RideButton
                variant="text-primary"
                text="Ver las 200 clínicas"
                size="medium"
                glyph={<RideGlRight />}
                glyphPosition="right"
                onClick={onShowClinics}
              />
            )}
          </div>
          <div className="plan-item-full_coverages">
            <div className="plan-item-full_coverages--title">
              <RideGlCoverageSolid size="large" />
              <p>{plan.coverages.length > 1 ? 'Coberturas' : 'Cobertura'}</p>
            </div>
            <div className="plan-item-full_coverages--list">
              {plan.coverages.map((coverage, i) => (
                <div key={`coverage-${i}`} className="plan-item-full_coverages--list-item">
                  <p dangerouslySetInnerHTML={{ __html: coverage.name }} />
                  <p>{coverage.description}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="plan-item-full_benefits">
            <div className="plan-item-full_benefits--title">
              <RideGlPremiumHealthSolid size="large" />
              <p>Más beneficios</p>
            </div>
            <div className="plan-item-full_benefits--list">
              {plan.benefits.map((benefit, i) => (
                <div key={`benefit-${i}`} className="plan-item-full_benefits--list-item">
                  <p>{benefit.name}</p>
                  <p>{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="plan-item-full_buttons">
            <RideButton text="Cotizar ahora" size="medium" onClick={onSelect} />
            <RideButton text="Conoce más" size="medium" variant="text-primary" onClick={onShowMore} />
          </div>
        </div>
      </div>
    </div>
  );
};

PlanItem.propTypes = {
  plan: PropTypes.shape({
    codPlan: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    priceDiscount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    period: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    showClinics: PropTypes.bool.isRequired,
    isRecommend: PropTypes.bool.isRequired,
    coverages: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
      }),
    ).isRequired,
    benefits: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
      }),
    ).isRequired,
    discount: PropTypes.arrayOf(
      PropTypes.shape({
        porcDescuento: PropTypes.number.isRequired,
      }),
    ).isRequired,
  }).isRequired,
  className: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onShowMore: PropTypes.func.isRequired,
  onShowClinics: PropTypes.func.isRequired,
};

PlanItem.defaultProps = {
  className: '',
};

export default PlanItem;
